import { QueryClient, QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';

import { retryOnAuthError } from 'app/shared/auth';

/**
 * Default retry policy: retry once on a 401 (refreshing the token first, see
 * `retryOnAuthError`) and fast-fail on everything else. Individual hooks may
 * still opt into their own retry behaviour.
 */
const QUERY_CLIENT = new QueryClient({
  defaultOptions: {
    queries: { retry: retryOnAuthError },
    mutations: { retry: retryOnAuthError },
  },
});

export const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => (
  <ReactQueryClientProvider client={QUERY_CLIENT}>{children}</ReactQueryClientProvider>
);
